import React from 'react';
import PropTypes from 'prop-types';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Icon from '@mdi/react';
import { iconPaths } from '../../constants/iconsList';
import 'react-loading-skeleton/dist/skeleton.css';

const MapSkeletonLoader = ({
  shouldEnableAnimation = false,
  width = '100%',
  height = '40vw',
  iconSize = 40,
  backgroundColor = '#E4E4E4',
  controlWidth = '80px',
  controlHeight = '38px',
  screenModeWidth = '38px',
  screenModeHeight = '38px',
  zoomControlSize = '38px',
}) => {
  return (
    <div style={{ position: 'relative', width, height }}>
      {/* Background skeleton to simulate the map area */}
      <Skeleton width={width} height={height} style={{ borderRadius: '10px' }} enableAnimation={shouldEnableAnimation} />

      {/* Map Controls - Top Left (Map/Satellite toggle) */}
      <div style={{
        position: 'absolute', top: '10px', left: '10px', display: 'flex', gap: '8px',
      }}
      >
        <SkeletonTheme baseColor={backgroundColor}>
          <Skeleton width={controlWidth} height={controlHeight} enableAnimation={shouldEnableAnimation} />
          <Skeleton width={controlWidth} height={controlHeight} enableAnimation={shouldEnableAnimation} />
        </SkeletonTheme>
      </div>

      {/* Map full screen mode - Top Right (toggle) */}
      <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
        <SkeletonTheme baseColor={backgroundColor}>
          <Skeleton width={screenModeWidth} height={screenModeHeight} enableAnimation={shouldEnableAnimation} />
        </SkeletonTheme>
      </div>

      {/* Map Controls - Bottom Right (Zoom controls) */}
      <div style={{
        position: 'absolute', bottom: '23px', right: '10px', display: 'flex', flexDirection: 'column', gap: '28px',
      }}
      >
        <SkeletonTheme baseColor={backgroundColor}>
          <Skeleton circle width={zoomControlSize} height={zoomControlSize} enableAnimation={shouldEnableAnimation} />
          <Skeleton width={zoomControlSize} height={zoomControlSize} enableAnimation={shouldEnableAnimation} />
        </SkeletonTheme>
      </div>

      {/* Centered loading marker placeholder */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: iconSize,
        height: iconSize,
        borderRadius: '50%',
        backgroundColor,
      }}
      >
        <Icon path={iconPaths.default} size={0.8} color="white" />
      </div>
    </div>
  );
};

MapSkeletonLoader.propTypes = {
  shouldEnableAnimation: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconSize: PropTypes.number,
  backgroundColor: PropTypes.string,
  controlWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  controlHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  screenModeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  screenModeHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  zoomControlSize: PropTypes.number,
};

export default MapSkeletonLoader;
